/* Happy path Vida Devolución 200% */
const SEGURO_VD = require("./seguro_vd.model.json");

/* Happy path Vida Plus */
const SEGURO_VD_PLUS = require("./seguro_vd_plus.model.json");

/* Happy path Seguro de Viajes */
const SEGURO_VIAJES = require("./seguro_viajes.model.json");

/* Happy path Vida Endosable */
const SEGURO_VE = require("./seguro_ve.model.json");

export const viewsModel = [...SEGURO_VD, ...SEGURO_VD_PLUS, ...SEGURO_VIAJES, ...SEGURO_VE];
